module.exports = __webpack_public_path__ + "assets/img/36_453_big.d3cc2c37.jpg";